import { transparentize } from "polished";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    width: 100%;
    box-shadow: 0 5px 20px ${transparentize(0.7, "black")};
    border-radius: 27px;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    position: relative;
    background-color: ${colors.brandMid};
    height: 225px;
`;

export const HeaderImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 32px;
`;

export const Title = styled.h3`
    background-color: ${colors.brandMid};
    color: white;
    padding: 0 16px 16px 16px;
    flex-grow: 1;
    font-size: 18px;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    padding: 16px;
`;
